<template>
    <transition name="slide-in" mode="in-out" >
  <div v-scroll-lock="sideOpen && !openingAnimation" v-if="sideOpen" class="side--container" :class="[options && options.class ? options.class : '']">
    <div 
      :class="['side--background',  sideOpen ? 'side--open' : '']" 
      @click="$emit('closeSide')" 
    />
        <section :key="sideOpen" :class="{ 'group--side': true, 'header--disabled': !$store.state.header_enabled }">
        <div class="side--padding">
            <img 
            class="side--padding--corner" 
            src="@/assets/images/side-corner-narrow.svg"
            >
            <div class="side--padding--bottom" />
        </div>
        <div 
            class="side--close" 
            @click="$emit('closeSide')"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="36.521" height="36.521" viewBox="0 0 36.521 36.521">
            <g id="Group_1147" data-name="Group 1147" transform="translate(-995 -94.204)">
            <circle id="Ellipse_62" data-name="Ellipse 62" cx="18.26" cy="18.26" r="18.26" transform="translate(995 94.204)" fill="#fff"/>
            <g id="Group_656" data-name="Group 656" transform="translate(1012.934 96.686) rotate(45)">
                <g id="Path_749" data-name="Path 749" transform="translate(0 0)">
                <path id="Path_751" data-name="Path 751" d="M22.983,11.5a1.239,1.239,0,0,1-.366.879,1.212,1.212,0,0,1-.879.374H12.745v8.993a1.263,1.263,0,0,1-1.254,1.245,1.238,1.238,0,0,1-.879-.366,1.212,1.212,0,0,1-.374-.879V12.754H1.245a1.256,1.256,0,0,1-.888-2.133,1.306,1.306,0,0,1,.888-.374h8.993V1.262a1.222,1.222,0,0,1,.374-.9A1.238,1.238,0,0,1,11.491,0a1.267,1.267,0,0,1,1.254,1.262v8.984h8.993A1.269,1.269,0,0,1,22.983,11.5Z" transform="translate(0)" fill="#6d66a2"/>
                </g>
            </g>
            </g>
        </svg>

        </div>
        <div class="content-container">
            <div class="option-container">
                <div class="header" :class="{'email-logs': options && options.email_logs}">
                    <h2 v-if="type=='sent_emails'">{{toLocal('email.sent_emails')}}</h2>
                    <h2 v-else>{{toLocal('users.email_receivers')}}</h2>
                  <div class="resend-button" v-if="options && options.email_logs && !options.readOnly">
                    <button 
                        class="btn" 
                        @click="resendEmails('all')"
                        v-if="sideUsers.filter(el=>el.log && el.log.status != 'sent').length > 0"
                      >
                        <font-awesome-icon icon="spinner" v-if="sendingAll" />
                        {{sendingAll ? toLocal('users.invitations_sending') : toLocal('emails.resend_to_all')}}
                      </button>
                  </div>
                </div>
            </div>
            <div class="row total">
                <span v-if="type=='sent_emails'">
                    {{toLocal('emails.sent_emails_2')}}: {{sideUsers.length}}
                </span>
                 <span v-else>
                    {{toLocal('users.total_recipients')}} {{sideUsers.length}}
                </span>
            </div>
            <div class="row table" >
                <div class="grid-table">
                <div class="table-row header">
                    <div class="table-cell">
                        <span class="name-cell header">
                                {{toLocal('generic.name')}}
                                <img
                                    v-if="orderByElement == 'name' && orderByDirection == 'desc'"
                                    src="@/assets/images/icons/order-by-desc.svg"
                                    @click="setOrderBy('name')"
                                >
                                <img
                                    v-if="orderByElement == 'name' && orderByDirection == 'asc'"
                                    src="@/assets/images/icons/order-by-asc.svg"
                                    @click="setOrderBy('name')"
                                >
                                <img
                                    v-if="orderByElement != 'name'"
                                    src="@/assets/images/icons/order-by.svg"
                                    @click="setOrderBy('name')"
                                >
                            </span>
                    </div>
                    <div class="table-cell">
                        <span class="header">
                                {{toLocal('generic.surname')}}
                                <img
                                    v-if="orderByElement == 'last_name' && orderByDirection == 'desc'"
                                    src="@/assets/images/icons/order-by-desc.svg"
                                    @click="setOrderBy('last_name')"
                                >
                                <img
                                    v-if="orderByElement == 'last_name' && orderByDirection == 'asc'"
                                    src="@/assets/images/icons/order-by-asc.svg"
                                    @click="setOrderBy('last_name')"
                                >
                                <img
                                    v-if="orderByElement != 'last_name'"
                                    src="@/assets/images/icons/order-by.svg"
                                    @click="setOrderBy('last_name')"
                                >
                            </span>
                    </div>
                    <div class="table-cell" v-if="type == 'user_list'">
                        <span class="header">
                                {{toLocal('generic.group')}}
                                <img
                                    v-if="orderByElement == 'groups' && orderByDirection == 'desc'"
                                    src="@/assets/images/icons/order-by-desc.svg"
                                    @click="setOrderBy('groups')"
                                >
                                <img
                                    v-if="orderByElement == 'groups' && orderByDirection == 'asc'"
                                    src="@/assets/images/icons/order-by-asc.svg"
                                    @click="setOrderBy('groups')"
                                >
                                <img
                                    v-if="orderByElement != 'groups'"
                                    src="@/assets/images/icons/order-by.svg"
                                    @click="setOrderBy('groups')"
                                >
                            </span>
                    </div>
                    <div class="table-cell" v-if="type == 'sent_emails'">
                        <span class="header">
                                {{toLocal('generic.date')}}
                                <img
                                    v-if="orderByElement == 'email.details.date' && orderByDirection == 'desc'"
                                    src="@/assets/images/icons/order-by-desc.svg"
                                    @click="setOrderBy('email.details.date')"
                                >
                                <img
                                    v-if="orderByElement == 'email.details.date' && orderByDirection == 'asc'"
                                    src="@/assets/images/icons/order-by-asc.svg"
                                    @click="setOrderBy('email.details.date')"
                                >
                                <img
                                    v-if="orderByElement != 'email.details.date'"
                                    src="@/assets/images/icons/order-by.svg"
                                    @click="setOrderBy('email.details.date')"
                                >
                            </span>
                    </div>
                    <div class="table-cell" v-if="type == 'user_list_emails'">
                        <span class="header">
                                {{toLocal('generic.email')}}
                                <img
                                    v-if="orderByElement == 'email' && orderByDirection == 'desc'"
                                    src="@/assets/images/icons/order-by-desc.svg"
                                    @click="setOrderBy('email')"
                                >
                                <img
                                    v-if="orderByElement == 'email' && orderByDirection == 'asc'"
                                    src="@/assets/images/icons/order-by-asc.svg"
                                    @click="setOrderBy('email')"
                                >
                                <img
                                    v-if="orderByElement != 'email'"
                                    src="@/assets/images/icons/order-by.svg"
                                    @click="setOrderBy('email')"
                                >
                            </span>
                    </div>
                </div>
                <div 
                  class="table-row parent" 
                  v-for="(user, user_id) in sideUsers" 
                  :key="user_id"  
                  :class="{'resend-row': (options && options.email_logs) && (user.log ? user.log.status != 'sent' : true),
                    'not-sent-row': (options && options.email_logs) && !user.log
                  }"
                >
                    <div 
                      v-if="$store.state.testUserStatsShowAll == 0" 
                      class="table-row"
                      v-tooltip="{content: (options && options.email_logs) ? user.log && user.log.status && (user.log.status != 'sent') ? toLocal('email.email_was_not_received') : user.log && !user.log.status ? toLocal('email.email_was_not_received') : !user.log ? toLocal('email.not_sent') : toLocal('email.email_sent') : '', classes:'tooltip-container icon-tooltip'}"
                    >
                        <div 
                          class="table-cell" 
                          :class="{'resend': (options && options.email_logs) && (user.log ? user.log.status != 'sent' : false),
                            'not-sent': (options && options.email_logs) && (!user.log)
                          }"
                        >
                            <svg v-if="!(options && options.email_logs)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 28 28">
                                <defs>
                                    <clipPath id="clip-path">
                                    <circle id="Ellipse_467" data-name="Ellipse 467" cx="14" cy="14" r="14" transform="translate(1212 2055.711)" fill="#fff" stroke="#707070" stroke-width="1"/>
                                    </clipPath>
                                </defs>
                                <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-1212 -2055.711)" clip-path="url(#clip-path)">
                                    <g id="Ellipse_464" data-name="Ellipse 464" transform="translate(1212 2055.711)" fill="#fff" stroke="#707070" stroke-width="1">
                                    <circle cx="14" cy="14" r="14" stroke="none"/>
                                    <circle cx="14" cy="14" r="13.5" fill="none"/>
                                    </g>
                                    <g id="Ellipse_465" data-name="Ellipse 465" transform="translate(1221 2062.711)" fill="#707070" stroke="#707070" stroke-width="1">
                                    <circle cx="5.5" cy="5.5" r="5.5" stroke="none"/>
                                    <circle cx="5.5" cy="5.5" r="5" fill="none"/>
                                    </g>
                                    <g id="Ellipse_466" data-name="Ellipse 466" transform="translate(1215 2070.711)" fill="#707070" stroke="#707070" stroke-width="1">
                                    <circle cx="11.5" cy="11.5" r="11.5" stroke="none"/>
                                    <circle cx="11.5" cy="11.5" r="11" fill="none"/>
                                    </g>
                                </g>
                                </svg>
                                <span  
                                    @mouseover="scrollNameHorizontal($event,true)" 
                                    @mouseleave="scrollNameHorizontal($event,false)"
                                >
                                  <div class="resend-container" v-if="options && options.email_logs " >
                                    <div @click="resendEmails(user.id,user)" class="resend-popper" v-if="!options.readOnly">
                                        <font-awesome-icon v-if="user.sending" icon="spinner" />
                                        <VTooltip v-else theme="users" :triggers="['hover']" :placement="'top'">
                                          
                                          <svg v-if="(user.log ? user.log.status != 'sent' : false) && (user.log && user.log.delivery_details ? user.log.delivery_details.description == 'invalid_address_format' : false)" width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.1538 7H0.846154C0.62174 7 0.406517 7.08429 0.247833 7.23431C0.0891481 7.38434 0 7.58783 0 7.8V21.4C0 21.8243 0.178296 22.2313 0.495665 22.5314C0.813035 22.8314 1.24348 23 1.69231 23H20.3077C20.7565 23 21.187 22.8314 21.5043 22.5314C21.8217 22.2313 22 21.8243 22 21.4V7.8C22 7.58783 21.9109 7.38434 21.7522 7.23431C21.5935 7.08429 21.3783 7 21.1538 7ZM18.9782 8.6L11 15.515L3.02183 8.6H18.9782ZM20.3077 21.4H1.69231V9.619L10.4278 17.19C10.5839 17.3255 10.7881 17.4007 11 17.4007C11.2119 17.4007 11.4161 17.3255 11.5722 17.19L20.3077 9.619V21.4Z" fill="#333333"/>
                                            <path d="M17.4663 9.79844C17.4663 10.5716 17.0484 11.1984 16.5329 11.1984C16.0175 11.1984 15.5996 10.5716 15.5996 9.79844C15.5996 9.02524 16.0175 8.39844 16.5329 8.39844C17.0484 8.39844 17.4663 9.02524 17.4663 9.79844Z" fill="white"/>
                                            <path d="M17.4663 6.06745C17.4663 7.87158 17.0484 9.33411 16.5329 9.33411C16.0175 9.33411 15.5996 7.87158 15.5996 6.06745C15.5996 4.26332 16.0175 2.80078 16.5329 2.80078C17.0484 2.80078 17.4663 4.26332 17.4663 6.06745Z" fill="white"/>
                                            <path d="M21.8788 0H11.1879C10.8728 0 10.5707 0.113461 10.3479 0.315423C10.1252 0.517386 10 0.791305 10 1.07692V12.9231C10 13.2087 10.1252 13.4826 10.3479 13.6846C10.5707 13.8865 10.8728 14 11.1879 14H21.8788C22.1938 14 22.496 13.8865 22.7187 13.6846C22.9415 13.4826 23.0667 13.2087 23.0667 12.9231V1.07692C23.0667 0.791305 22.9415 0.517386 22.7187 0.315423C22.496 0.113461 22.1938 0 21.8788 0ZM16.5333 9.15385C16.7095 9.15385 16.8818 9.20122 17.0283 9.28997C17.1748 9.37872 17.289 9.50486 17.3564 9.65245C17.4239 9.80004 17.4415 9.96243 17.4071 10.1191C17.3727 10.2758 17.2879 10.4197 17.1633 10.5327C17.0387 10.6456 16.88 10.7225 16.7071 10.7537C16.5343 10.7849 16.3552 10.7689 16.1924 10.7077C16.0296 10.6466 15.8905 10.5431 15.7926 10.4103C15.6947 10.2774 15.6424 10.1213 15.6424 9.96154C15.6424 9.74733 15.7363 9.54189 15.9034 9.39041C16.0704 9.23894 16.297 9.15385 16.5333 9.15385ZM15.9394 7.53846V3.76923C15.9394 3.62642 16.002 3.48946 16.1134 3.38848C16.2247 3.2875 16.3758 3.23077 16.5333 3.23077C16.6909 3.23077 16.8419 3.2875 16.9533 3.38848C17.0647 3.48946 17.1273 3.62642 17.1273 3.76923V7.53846C17.1273 7.68127 17.0647 7.81823 16.9533 7.91921C16.8419 8.02019 16.6909 8.07692 16.5333 8.07692C16.3758 8.07692 16.2247 8.02019 16.1134 7.91921C16.002 7.81823 15.9394 7.68127 15.9394 7.53846Z" fill="#F86565"/>
                                          </svg>
                                          <svg v-else-if="(user.log ? user.log.status != 'sent' : false) && (user.log && user.log.delivery_details ? user.log.delivery_details.description == 'mailbox_full' : false)" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" fill="white"/>
                                            <path d="M26.1538 8H5.84615C5.62174 8 5.40652 8.08429 5.24783 8.23431C5.08915 8.38434 5 8.58783 5 8.8V22.4C5 22.8243 5.1783 23.2313 5.49567 23.5314C5.81303 23.8314 6.24348 24 6.69231 24H25.3077C25.7565 24 26.187 23.8314 26.5043 23.5314C26.8217 23.2313 27 22.8243 27 22.4V8.8C27 8.58783 26.9109 8.38434 26.7522 8.23431C26.5935 8.08429 26.3783 8 26.1538 8ZM23.9782 9.6L16 16.515L8.02183 9.6H23.9782ZM25.3077 22.4H6.69231V10.619L15.4278 18.19C15.5839 18.3255 15.7881 18.4007 16 18.4007C16.2119 18.4007 16.4161 18.3255 16.5722 18.19L25.3077 10.619V22.4Z" fill="#333333"/>
                                            <rect x="10" y="13" width="20" height="15" fill="white"/>
                                            <path d="M30.1538 12H9.84615C9.62174 12 9.40652 12.0843 9.24783 12.2343C9.08915 12.3843 9 12.5878 9 12.8V26.4C9 26.8243 9.1783 27.2313 9.49567 27.5314C9.81303 27.8314 10.2435 28 10.6923 28H29.3077C29.7565 28 30.187 27.8314 30.5043 27.5314C30.8217 27.2313 31 26.8243 31 26.4V12.8C31 12.5878 30.9109 12.3843 30.7522 12.2343C30.5935 12.0843 30.3783 12 30.1538 12ZM27.9782 13.6L20 20.515L12.0218 13.6H27.9782ZM29.3077 26.4H10.6923V14.619L19.4278 22.19C19.5839 22.3255 19.7881 22.4007 20 22.4007C20.2119 22.4007 20.4161 22.3255 20.5722 22.19L29.3077 14.619V26.4Z" fill="#333333"/>
                                            <rect x="17" y="5" width="14" height="11.2" rx="2" fill="#F86565"/>
                                            <path d="M26.4506 8.29297C25.4245 8.29297 24.6812 9.01563 24.0001 9.83606C23.319 9.01563 22.5762 8.29297 21.5506 8.29297C20.1997 8.29297 19.1006 9.32739 19.1006 10.5988C19.0998 10.9014 19.1626 11.2012 19.2852 11.4809C19.4079 11.7606 19.5881 12.0147 19.8155 12.2286C20.042 12.4435 20.3115 12.614 20.6085 12.73C20.9056 12.8461 21.2241 12.9055 21.5457 12.9047H21.5516C22.5752 12.9024 23.318 12.1798 23.9996 11.3593C24.6812 12.1811 25.4245 12.9047 26.4506 12.9047C27.8015 12.9047 28.9006 11.8703 28.9006 10.5988C28.9006 9.32739 27.8015 8.29297 26.4506 8.29297ZM21.5496 11.9824L21.5457 12.4436V11.9824C21.1542 11.9824 20.7862 11.8385 20.5098 11.5775C20.305 11.3836 20.1657 11.137 20.1095 10.8687C20.0533 10.6005 20.0827 10.3226 20.194 10.07C20.3053 9.81746 20.4934 9.60154 20.7349 9.44944C20.9763 9.29735 21.2601 9.21589 21.5506 9.21532C22.2023 9.21532 22.805 9.87849 23.3861 10.5979C22.804 11.3169 22.2013 11.981 21.5496 11.9824ZM26.4506 11.9824C25.7989 11.9824 25.1957 11.3183 24.6136 10.5979C25.1952 9.87849 25.7979 9.21532 26.4506 9.21532C27.261 9.21532 27.9206 9.83606 27.9206 10.5988C27.9206 11.3616 27.261 11.9824 26.4506 11.9824Z" fill="white"/>
                                          </svg>
                                          <svg v-else-if="(user.log ? user.log.status == 'sent' : false) && (user.sending == false)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="24" height="24" rx="12" fill="#4D4D4D"/>
                                            <path d="M17.7958 9.07878L10.4134 15.8143C10.3491 15.8731 10.2727 15.9199 10.1885 15.9517C10.1044 15.9836 10.0142 16 9.92311 16C9.83202 16 9.74183 15.9836 9.6577 15.9517C9.57358 15.9199 9.49717 15.8731 9.43288 15.8143L6.20306 12.8675C6.13868 12.8088 6.08762 12.739 6.05277 12.6623C6.01793 12.5855 6 12.5033 6 12.4202C6 12.3371 6.01793 12.2549 6.05277 12.1781C6.08762 12.1014 6.13868 12.0317 6.20306 11.9729C6.26744 11.9142 6.34387 11.8676 6.42799 11.8358C6.5121 11.804 6.60226 11.7877 6.6933 11.7877C6.78435 11.7877 6.8745 11.804 6.95862 11.8358C7.04273 11.8676 7.11916 11.9142 7.18354 11.9729L9.92369 14.473L16.8165 8.18527C16.9465 8.06664 17.1228 8 17.3067 8C17.4906 8 17.6669 8.06664 17.7969 8.18527C17.927 8.30389 18 8.46479 18 8.63255C18 8.80031 17.927 8.9612 17.7969 9.07983L17.7958 9.07878Z" fill="white"/>
                                          </svg>
                                          <svg v-else-if="user.log ? user.log.status != 'sent' : false" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.1538 0H0.846154C0.62174 0 0.406517 0.0842856 0.247833 0.234315C0.0891481 0.384344 0 0.587827 0 0.8V14.4C0 14.8243 0.178296 15.2313 0.495665 15.5314C0.813035 15.8314 1.24348 16 1.69231 16H20.3077C20.7565 16 21.187 15.8314 21.5043 15.5314C21.8217 15.2313 22 14.8243 22 14.4V0.8C22 0.587827 21.9109 0.384344 21.7522 0.234315C21.5935 0.0842856 21.3783 0 21.1538 0ZM18.9782 1.6L11 8.515L3.02183 1.6H18.9782ZM20.3077 14.4H1.69231V2.619L10.4278 10.19C10.5839 10.3255 10.7881 10.4007 11 10.4007C11.2119 10.4007 11.4161 10.3255 11.5722 10.19L20.3077 2.619V14.4Z" fill="black"/>
                                          </svg>
                                            <template #popper>
                                              {{toLocal('generic.resend')}}
                                            </template>
                                      </VTooltip>
                                    </div>
                                    {{user.name}}
                                  </div>
                                  {{options && options.email_logs ? '' : user.name}}

                            </span>
                            </div>
                        <div class="table-cell">
                            <span
                                @mouseover="scrollNameHorizontal($event,true)" 
                                @mouseleave="scrollNameHorizontal($event,false)"
                            >
                                {{user.last_name}}
                            </span>
                        </div>
                        <div class="table-cell" v-if="type=='sent_emails'">
                          {{ user.email.details.date }}
                        </div>
                        <div class="table-cell" v-else-if="type=='user_list_emails'">
                          <span
                                @mouseover="scrollNameHorizontal($event,true)" 
                                @mouseleave="scrollNameHorizontal($event,false)"
                                :class="{
                                  'error': !isValidEmail(user.email) || ((user.log && user.log.status != 'sent') && (user.log.delivery_details && user.log.delivery_details.description == 'invalid_address_format'))
                                }"
                                
                            >
                              <span v-if="!user.editing" @click="editEmail(user)">
                                {{user.email}}
                              </span>
                              <input 
                                type="text"
                                ref="emailInput"
                                v-if="user.editing"
                                v-model.lazy="user.email"
                                maxlength="100"
                                class="email-input"
                                @blur="$set(user, 'editing', false);saveUserData(user)" 
                              />
                          </span>
                        </div>
                        <div v-else class="table-cell" @mouseover="hoveringItem = user_id" @mouseleave="hoveringItem = -1" >
                            <div class="group--wrapper" >
                                <div class="group--parent--container">
                
                                    <div
                                    v-for="(group, groupIndex) in user.groups"
                                    :key="groupIndex"
                                    
                                    :style="{'max-width': user.groups.length > 3 ? `${100 / user.groups.length}%` : '', 'margin': '0 0.3rem', 'margin-left': groupIndex != 0 ? `-${user.groups.length-1}%` : `${user.groups.length-1}%`}"
                                    class="group--item"
                                    
                                    >

                                    <VTooltip v-if="hoveringItem == user_id" theme="users"  :triggers="['hover']" :placement="'top'">
                                        <div  :class="['group', 'g'+(groupIndex + 1), 'c'+group.color_id]">
                                        {{ group.name[0] }}
                                        </div>
                                            <template #popper>
                                        {{group.name}}
                                    </template>
                                    </VTooltip>
                                     <div v-else  :class="['group', 'g'+(groupIndex + 1), 'c'+group.color_id]">
                                        {{ group.name[0] }}
                                    </div>

                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                    
                </div>
                
            </div>
            </div>
            <span v-if="loadingUsers">
                  <font-awesome-icon icon="spinner" />
            </span>
        </div>
    </section>
  </div>
    </transition>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import { ObserveVisibility } from 'vue-observe-visibility'
export default {
  name: "NewGroupSide",
  data: function(){
    return {
      openingAnimation: false,
      sideUsers: [],
      orderByElement: "",
      orderByDirection: "",  
      loadingUsers: false,
      hoveringItem: -1,
      busy:false,
      sendingAll: false
    }
  },
  directives:{ObserveVisibility},

  props:{

      sideOpen:{
        type: Boolean,
        default: false
      },
      users:{
        type: [Array, String],
      },
      usersType:{
          type: String,
    },
    type: {
      type: String,
      default: 'user_list'
    },
    options:{
      type: Object,
    },
    selectedEmail: {
      type: Object,
      default: null
    },
  },

  beforeDestroy() {
    this.sideOpen = false;
       
  },

  watch:{
     
      sideOpen(newValue, oldValue){
      if (newValue) {
        if(this.type == 'user_list_emails'){
          this.sideUsers = this._.cloneDeep(this.users);
          if(this.options && !this.options.email_logs){
             this.sideUsers.sort((a,b) =>{
              if(this.isValidEmail(a.email) && this.isValidEmail(b.email)){
                return a.email.localeCompare(b.email);
              }else if(this.isValidEmail(a.email) && !this.isValidEmail(b.email)){
                return 1;
              }else if(!this.isValidEmail(a.email) && this.isValidEmail(b.email)){
                return -1;
              }else{
                return a.name.localeCompare(b.name);
              }
            })
          }
        }
        else{
          this.loadUsers();
        }
          
        }
      },
  },
  methods: {
    isValidEmail(email){
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    },
    loadUsers(){
        this.loadingUsers =true;
        let user_ids = this.users != 'all' ? this.users.map(el=>el.id) : 'all';
        axios.post(
        `${this.$store.state.api_link}/email-templates/users`,
        {users: user_ids, type:this.usersType},
        this.$store.getters.axiosConfig()
        ).then((response) => {
            let users = response.data;
            users.forEach(user=>{
                delete user.ended_percent;
                delete user.training_count;
                delete user.started_percent;
                delete user.enabled;
                delete user.email;
                delete user.role;
                user.visible =false;
            })
            this.sideUsers = users;
            if(this.type == 'sent_emails')
              this.loadSentEmails();
            else {
              this.loadingUsers = false;
            }
        })
        .catch(() => {
            this.loadingUsers =false;

        });
    },
    loadSentEmails() {
      this.loadingUsers =true;
          axios.get( 
              `${this.$store.state.api_link}/email-templates/${this.selectedEmail.id}/sent-emails`,
              this.$store.getters.axiosConfig()
          ).then((response) => {
            let sent_email_rows = response.data;
            sent_email_rows.forEach((user, i)=>{
              let index = this.sideUsers.findIndex(el => el.id == user.recipient_id);
              if (index != -1) {
                let temp_user = this._.cloneDeep(this.sideUsers[index]);
                temp_user.email = this._.cloneDeep(user);
                sent_email_rows[i] = temp_user;
              }
              else sent_email_rows[i] = null;
            })
            sent_email_rows = sent_email_rows.filter(el => el != null);
            this.sideUsers = sent_email_rows;
            this.loadingUsers =false;
          }).catch((error) => {
            this.loadingUsers =false;
            console.log(error)
          });
      },
    visibilityChanged(isVisible, entry, user){
        if(isVisible){
            this.$set(user, 'visible', true);
        }
        else{
            this.$set(user, 'visible', false);
        }
    },
    setOrderBy(element) {
            if(element == this.orderByElement){
                this.orderByDirection = this.orderByDirection == "desc" ? "asc" : "desc";
            }else{
                this.orderByElement = element;
                this.orderByDirection = "asc";
            }
        
            if(isNaN(this.users[0][element])){
              if (this.orderByDirection == "desc") {
                if (element == 'email.details.date')
                  this.sideUsers.sort((a,b) => b.email.details.date.localeCompare(a.email.details.date)); 
                else
                    this.sideUsers.sort((a,b) => b[element].localeCompare(a[element])); 
              } else {
                if (element == 'email.details.date')
                  this.sideUsers.sort((a, b) => a.email.details.date.localeCompare(b.email.details.date));
                else
                  this.sideUsers.sort((a,b) => a[element].localeCompare(b[element]));  
              }
            }else{
                if(this.orderByDirection == "desc"){
                this.sideUsers.sort((a,b) => (a[element] > b[element]) ? -1 : ((b[element] > a[element]) ? 1 : 0)); 
                }else{
                this.sideUsers.sort((a,b) => (a[element] > b[element]) ? 1 : ((b[element] > a[element]) ? -1 : 0)); 
                }
            }
        },
        resendEmails(user_id, user = null){
          if(user){
            if(user.log && user.log.status == 'sent') return;
            if(!this.isValidEmail(user.email)){
              this.$set(user, 'editing', true);
              this.$nextTick(() => {
                this.$refs.emailInput[0].focus();
              });
              return;
            }
            this.$set(user, 'sending', true);
            user = [user];
          }
          if(user_id == 'all'){
            if(this.sideUsers.filter(el=>el.log && el.log.status != 'sent').length == 0) return;
            this.sendingAll = true;
            user = this.sideUsers.filter(el=>el.log && el.log.status != 'sent' && this.isValidEmail(el.email));
          }
          
          this.$emit('resendEmails', user_id, user)
        },
        editEmail(user){
          if(!((this.options && this.options.email_logs) && (user.log ? user.log.status != 'sent' : false))){
            if(this.isValidEmail(user.email)) return;
          }
          if(user.editing) return;
          this.$set(user, 'editing', true);
          this.$nextTick(() => {
            this.$refs.emailInput[0].focus();
          });
        },
        saveUserData(user){
          if(this.isValidEmail(user.email))
            this.$emit('saveUserData', user);
        }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_progressbars.scss";
.side--container{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: calc(100vw - 80px);
    height: 100vh;
    overflow: hidden;
}

    .side--background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      background-color: rgba(0,0,0,.5);
      content: '';
      display: block;
      opacity: 0;
      pointer-events: none;
      transition: .3s opacity;

      &.side--open {
        opacity: 1;
        pointer-events: auto;
        z-index: 99;
      }
    }
    .group--side {
        position: absolute;
        right: 0rem;
        background-color: #fff;
        height: calc(100vh - 11vh);
        width: 750px;
        z-index: 99;
        top: 0;
        font-family: var(--main-site-font);
        transition: .3s right;
        // animation: openSide 0.5s forwards;

        &.side--open {
          right: 0rem;
          z-index: 99;
            top: 0;
        }

        &.header--disabled {
          height: 100vh;
          top: 0px;
        }
    }
    @keyframes openSide{
        0% {
            right: -45rem;
        }
        100% {
            right: 0rem;
        }
    }
    .side--content {
        overflow: auto;
        height: 100%;
        padding: 60px 50px;
        padding-left: 20px;
        overflow-x: hidden;
    }

    .side--close {
        position: absolute;
        left: -100px;
        top: 44px;
        border: transparent;
        // border-right: 20px solid #EFEFEF;
        padding: 20px;
        border-radius: 100%;
        width: 87px;
        height: 87px;
        cursor: pointer;
        user-select: none;

        svg {
            width: 47px;
            height: 47px;
            path{
              fill: var(--primary-color);
            }
        }
    }

    .side--padding {
      position: absolute;
      margin-left: -35px;
      margin-top: -80px;
      width: 40px;
      
      .side--padding--corner {
        height: 250px;
        display: block;
      }

      .side--padding--bottom {
        height: calc(100vh - 150px);
        width: 35px;
        background-color: #fff;
        margin-top: -4px;
      }
    }
.header{
  display: flex;
  flex-direction: column;
  width: 100%;
  &.email-logs{
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 2px solid #AAAAAA;
    margin-bottom: 1rem;
    h2{
      margin: 0;
      border-bottom: none;
    }
  }
  h2{
    width: 100%;
    padding: 0.5rem 1.5rem;
    border-bottom: 2px solid #AAAAAA;

  }

}
.row{
    &.total{
        padding: 0 1.5rem;
        margin-bottom: 1rem;
    }
    &.table{
        display: flex;
        flex-direction: column;
    }
}
.resend-container{
  display: flex;
  align-items: center;
  gap: 4px;
  div{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    cursor: pointer;
    svg{
      height: initial !important;
      width: initial !important;
    }
    &:hover{
      background-color: #EFEFEF;
      // svg{
      //   path{
      //     fill: #333;
      //   }
      // }
    }
  }
  
}
    .group--section--select {
      margin-top: -60px;

      .group--section--select--button {
        width: 50%;
        float: left;
        color: #fff;
        font-size: 20px;
        font-weight: 900;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        text-align: center;
        padding: 15px 0;
        cursor: pointer;
        user-select: none;
        background-color: $background_color;
        box-shadow: 0 0 5px rgba(0,0,0,0);
        transition: .3s box-shadow, .3s background-color;

        &.active, &:hover {
          box-shadow: 0 0 5px rgba(0,0,0,.3);
          background-color: $group_color;
        }
      }

      &:after {
        content: '';
        display: block;
        clear: both;
      }
    }

    .group--title{ 
      font-size: 35px;
      padding-top: 15px;
      font-weight: 900;
      padding-left: 30px;

      span {
        font-size: 35px;
        display: block;
      }
    }

    .lesson--list {
      position: relative;
    }

    .side--table--control {
      margin-top: 50px;
      width: 100%;
      margin: 0;
      position: absolute;
      // right: 0;
      left: 0;
      transition: .3s left;

      &.hidden {
        left: calc(-100% - 150px);

        &.search--table {
          left: calc(200% + 150px);
        }
      }
      
      tr {
        border-radius: 35px;
      }

      svg {
        margin-top: -2px;
      }

      &.search--table {

        tr td {
          border-top: 1px solid #464646;
          border-bottom: 1px solid #464646;

          &:first-child {
            border-left: 1px solid #464646;
          }
          &:last-child {
            border-right: 1px solid #464646;
          }
        }
        svg {
          margin-top: -9px;
        }
      }
    }
    .group--button--container{
      display: flex;
      .filter-button{
        flex: 1;
        border-radius: 35px;
        margin-top: 20px;
        margin-left: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
    }

    .group--add--button {
      flex: 2;
      padding: 12px;
      border-radius: 35px;
      padding-right: 35px;
      cursor: pointer;
      user-select: none;
      transition: 1s background-color, .3s transform, .3s box-shadow;
      // background-color: #EFEFEF;
      // margin: 0 -35px;
      margin-top: 20px;

      .group--add--button--icon {
        width: 45px;
        height: 45px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--primary-color);
        border-radius: 100%;
        vertical-align: middle;

        svg {
          max-width: 28px;
          max-height: 28px;
          fill: var(--primary-color);
        }
      }

      .group--add--button--title {
        display: inline-block;
        vertical-align: middle;
        padding-left: 20px;
        margin-left: 20px;
        border-left: 1px solid #707070;
        width: calc(100% - 70px);

        input {
          background: transparent;
          border: none;
          outline: none;
          color: $font_color;
          font-size: 20px;
          font-family: var(--main-site-font);
          width: calc(100% - 40px);
          -webkit-user-select: text;
        }
      }

      &:hover {
        box-shadow: 0px 3px 6px #00000033;
        transform: translateY(-3px);
      }
    }
    .inactive{
      td{
        background: #EFEFEF;
      }
    }
    .content-container{
        display: flex;
        flex-direction: column;
        padding: 1rem;
        height: 100%;
        overflow: auto;
        color: var(--primary-color);
        z-index: 99;
        top: 0;

        .row{
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            h3{
              font-weight: 300;
              color: var(--primary-color);
              border-bottom: 2px solid #AAAAAA;
              padding: 0.5rem 1.5rem;
            }
            &.top{
              z-index: 2;
            }
            &.bottom{
              z-index: 1;
            }
        }
        .grid-row{
            display: grid;
            width: 100%;
            align-items: center;
            &.header{
                width: 95%;
                grid-template-columns: 70% 30%;
                h2{
                    padding: 0.25rem 1rem;
                }
            }
        }
         .grid-buttons{
            display: grid;
            grid-template-rows: 1fr;
            grid-template-columns: 3fr 2fr 2fr;
            grid-template-areas: 
                "label button button2";
            gap: 1rem 0.25rem;
            align-items: center;
            padding-left: 1.5rem;
            span{
              font-size: clamp(16px, 0.8vw, 18px);
              width: 45%;
            }
            .grid-row{
                width: 100%;
            }
            width: 100%;
            span:first-child{
                grid-area: label;
            
            }
            .btn:first-child{
                grid-area: button;
            }
            .dropdown{
                grid-area: dropdown;
            }
            &.flex{
              display: flex;
              span{
                width: 50%;
              }
              .btn{
                margin: 0 0.25rem;
              }
            }
        }
    }
    .row-dropdown{
        width: 100%;
        margin-top: 1rem;
        padding-left: 1.5rem;
        span{
          min-width: 17%;
          display: flex;
          font-size: clamp(16px, 0.8vw, 18px);
        }
        .long{
          min-width: 35%;
        }
    }
    .dropdown{
        display: flex;
        position: relative;
        background: #efefef;
        border-radius: 2rem;
        padding: 0.25rem 0.5rem;
        justify-content: space-between;
        cursor: pointer;
        width: 100%;
        z-index: 2;
        height: 25px;
        margin: 0;
        margin-left: 0.75rem;
        border: 1px solid var(--primary-color-opacity-50)
        span{
            width: 100%;
            font-size: clamp(14px, 1vw, 16px);
        }
        .dropdown-icon{
            background: white;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            padding: 0.25rem;
            min-width: 1rem;
            width: 1rem;
            min-height: 1rem;
        }
        .btn-container{
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;  
          cursor: pointer;
          .title{
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            min-width: 86%;
            width: 14px;
          }
        }
        .dropdown-list{
          position: absolute;
          left: 0;
          width: 100%;
          padding: 0.25rem;
          top: 0.5rem;
          padding-top: 1rem;
          border-radius: 1rem;
          
          background: #efefef;
          border: none;
          border-top: none;
          z-index: -1;
          &.multi{
            padding-bottom: 0;
            overflow: hidden;
          }
          .list-item{
            font-size: clamp(14px, 0.8vw, 18px);
            margin: 0.5rem 0;
            user-select: none;
            &.multichoice{
              display: flex;
              align-items: center;
              .checkbox{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 1.5rem;
                width: 1.5rem;
                background: white;
                border-radius: 50%;
                margin-right: 0.5rem;
                &.active{
                  background: var(--secondary-color);
                }
                svg{
                  transform: rotate(0deg);
                  path{
                    stroke: var(--primary-color);
                  }
                }
              }
            }
            &:hover{
              font-weight: 700;
            }
           
            &.active{
              font-weight: 700;
            }
          }
          .dropdown-wrapper{
            display: flex;
            flex-direction: column;
            max-height: 14rem;
            overflow-y: auto;
            overflow-x: hidden;
          }
        }
        &.white{
            background: white;
            .dropdown-icon{
                background: #efefef;
            }
            .dropdown-list{
              background: white;
            }
        }
        &.small{
            padding: 0.2rem 0.25rem;
            width: 4.5rem;
            .btn-container{
              background: white;
            }
            span{
                text-align: center;
                font-size: clamp(0.7em, 1.1vw, 1em);
            }
        }
        &.big{
          height: 37px;
          border: 1px solid var(--primary-color-opacity-50);
            padding: 0.25rem 0.25rem 0.25rem 0.5rem;
          .dropdown-icon{
            height: 25px;
            width: 25px;
          }
          .dropdown-list{
            .list-item{
                &:first-child{
                  // border-top: 1px solid var(--primary-color);
                  padding-top: 0.5rem;
                  // margin-top: 0.75rem;
              }
            }
          }
        }
        &.top{
          z-index: 3;
        }
        &.bottom{
          z-index: 2;
        }
        &.active{
          padding: 0;
          border-bottom: none;
          background: none;
          border: none;
          .btn-container{
            background: #efefef;  
            padding: 0.25rem 0.5rem;
            border: 1px solid var(--primary-color-opacity-50);
            border-radius: 1rem;

          }
          svg{
            transform: rotate(180deg);
          }
          &.small{
            .btn-container{
              background: white;
              border: none;
              padding: 0.2rem 0.25rem;
            }
            .dropdown-list{
                top: 0;
                  border-radius: 0.75rem;
                .list-item:first-child{
                  border-top: 1px solid;
                  padding-top: 0.25rem;
                  margin-top: 5px;
                }
            }
          }
        }
        &.hidden{
          opacity: 0;
        }
    }
    
    .training-count{
        display: flex;
        margin: 0 0rem 0 2rem;
        padding: 0 1.5rem;
        .label, .number{
          font-size: clamp(16px, 0.8vw, 18px);
        }
    }
    .number{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height:3rem;
        min-width: 3rem;
        border-radius: 50%;
        background: #efefef;
        // border: 1px solid var(--primary-color);
        color: var(--primary-color);
        font-weight: 700;
        font-size: clamp(1em, 1.2vw, 18px);

    }
   
    .btn{
        display: flex;
        width: 100%;
        // margin: 0 0.25rem;
        justify-content: center;
        border-radius: 2rem;
        font-size: clamp(0.5em, 1vw, 16px);
        border: 1px solid var(--primary-color);
        color: var(--primary-color);
        cursor: pointer;
        height: 30px;
        align-items: center;
        &.active{
          background: var(--secondary-color);
          border: 1px solid var(--secondary-color);
          font-weight: 900;

        }
    }
.slide-in-enter-active, .slide-in-leave-active {
        transition: right .3s;

    .group--side{
        transition: right .3s;

    }
}
.slide-in-enter, .slide-in-leave-to /* .fade-leave-active below version 2.1.8 */ {
     .group--side{
         
        right: -45rem;
    }
}
.training-user-list{
  top: 11vh;
  width: calc(100vw);
  .grid-table .table-row .table-cell{
    padding: 0 5px;
  }
}

.grid-table .table-row{
  &.resend-row{
    &.parent{
      border: 2px solid #F86565;
      background: white;
      .table-row{
        background: white;
      }
    }
  }
  &.not-sent-row{
    &.parent{
      border: 2px solid #000000;
      background: white;
      .table-row{
        background: white;
      }
    }
    .resend-container{
      .resend-popper{
        visibility: hidden;
      }
    }
  }
}
.grid-table{
    display: grid;
    grid-template-rows: auto;
    width: 100%;
    .table-row{
        display: grid;
        grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr) ;
        margin: 0.25rem 0;
        padding: 0.25rem 0.5rem;
        border-radius: 1rem;
        background: #efefef;
        &.header{
            display: flex;
            flex-direction: row;
            background: white;
            font-weight: 700;
            color: var(--primary-color);
        }
        &.parent{
            grid-template-columns:1fr;
            margin: 0.25rem 0;
            padding:0;
        }
        .table-cell{
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            width: 100%;
            padding: 0;
            border-left: 1px solid var(--primary-color);
            &:first-child{
                border-left: none;
            }
            span{
                display: block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 100%;
                height: 100%;
                margin:0 auto;
                justify-content: center;
                &.name-cell{
                    margin-left: 1.7rem;
                }
                img{
                    margin: 0 0.25rem;
                }
                &.header{
                    display: flex;
                    flex-direction: row;
                   white-space: normal;
                }
            }

            svg{
                height: 100%;
                width: 1.7rem;
                
            }
            .error{
              position: relative;
              &::before{
                content: '';
                position: absolute;
                height: 2px;
                background-color: #F86565;
                width: 100%;
                bottom: 0;
                left: 0;
              }
            }
        }
    }
}
.resend-button{
  .btn{
    white-space: nowrap;
    background-color: #E2E2E2;
    border: none;
    color: #333;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  }
}
.email-input{
  border: none;
  font-family: var(--main-site-font);
  color:#000000;
  width: 100%;
  font-size: 1rem;
  background-color: transparent;
  border-bottom: 2px solid #F86565;
}
.group--wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  padding: 0;
  padding-right: 10px;
  position: relative;
  padding: 0;
  // float: right;
  border-top-right-radius: 35px;
  border-bottom-right-radius: 35px;
  overflow: hidden;
    justify-content: center;

  .group--parent--container{
    position: relative;
    display: flex;
    width: 100%;
  }
  &:hover .group {
    @for $i from 2 through 15 {
      &.g#{$i} {
        width: 10% - ($i - 1) * 4;
      }
    }
  }
  
.group--item {
  display: flex;
  justify-content: center;
  align-items: center;

  // position: relative;
  width: 100%;
  overflow: visible;
}
  .group {
    // position: relative;
    width: 100%;
    height: 100%;
    border-top-right-radius: 35px;
    border-bottom-right-radius: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .3s width;
    user-select: none;
    border-radius: 50%;
    min-width: 40px;
    height: 40px;
    max-width: 40px;
    font-size: clamp(24px, 2vh, 30px);

    // @for $i from 0 through 15 {
    //   &.c#{$i} {
    //     background-color: hsl((3 + ($i - 1) * 24), 100%, 76%);
    //   }
    //   &.g#{$i} {
    //     width: 100% - ($i - 1) * 10;
    //   }
    // }
     @for $i from 0 through 15 {
      &.c#{$i} {
        background-color: hsl(($i * 40 % 360), (20 + 2.5 * $i) % 70 * 1%, var(--theme-lightness));
      }
      &.g#{$i} {
        width: 100% - ($i - 1) * 10;
      }
    }

    &:hover {
      @for $i from 0 through 15 {
        &.g#{$i} {
          width: 100% - ($i - 1) * 2;
        }
      }
    }
  }
}

</style>
